export const selectCartWidgetVisible = state => state.cart.widget.visible;
export const selectCartWidgetShowPrices = state => state.cart.widget.prices;